import { DayOfWeek } from '@askporter/client-grieg-lyric';
import { days } from './';

export const sortDays = (a: string | DayOfWeek, b: string | DayOfWeek): number => {
  return days[a as DayOfWeek] - days[b as DayOfWeek];
};
